/* global products jQuery */
import {h, render} from 'preact'
// wp_enqueue_script: underscore
import FontMenu from './components/FontMenu'
import FontList from './components/FontList'
import {FontPageActions, FontPageStore} from './actions/actions'
import BuyingOptions, {invokeBuyingOptions} from './components/BuyingOptions'
// wp_enqueue_script: jquery
const $ = jQuery

var supportsPassive = false
try {
  var opts = Object.defineProperty({}, 'passive', { get: function() {
    supportsPassive = true
  }})
  window.addEventListener("testPassive", null, opts)
  window.removeEventListener("testPassive", null, opts)
} catch (e) {}

function passive () {
  return supportsPassive ? { passive: true} : false
}

// render font menu
render(
  <FontMenu />, document.getElementById('fonts-menu')
)

// render the font list
render(
  <FontList />,
  document.getElementById('font-list')
)

FontPageStore.listVisibilityChanged.add(function (visible) {
  if (visible) {
    $('#content.container').hide()
    $('#secondary-header .font-types').show().css('visibility', 'visible')
    if (FontPageStore.activeFilter === 'all') {
      $('#secondary-header .font-types a[data-font-filter="all"]')
        .addClass('active')
    }
    if (!/^\/fonts\/?$/.test(window.location.pathname)) {
      $(document.body).removeClass('home')
      window.history.pushState({}, 'Fonts - Terminal Design', '/fonts')
      $('#secondary-header .buying-menu').hide()
      $('#secondary-header .buying-menu.fonts-page-menu').show()
    }
  } else {
    $('#content.container').show()
    $('#secondary-header .font-types').hide()
    $('#secondary-header .buying-menu').show()
    $('#secondary-header .buying-menu.fonts-page-menu').hide()
    if (window.location.pathname === '/') {
      $(document.body).addClass('home open-menu')
    }
  }
})
// Add the history back button event handler to re-hide the font-list, and show the content
window.onpopstate = function (event) {
  if (!/^\/(fonts|collections)\/?$/.test(window.location.pathname)) {
    FontPageActions.makeListHidden()
  } else {
    FontPageActions.makeListVisible()
  }
}
if (/^\/(fonts|collections)\/?$/.test(window.location.pathname)) {
  $('#content.container').hide()
}

// wire up the font list filter buttons
$('.showall-fonts a').click(event => {
  event.preventDefault()
  FontPageActions.filterByClassification('all')
  closeMega(true)
})
$('.showselected-fonts a').click(event => {
  event.preventDefault()
  if (!/^\/fonts\/?$/.test(window.location.pathname)) {
    FontPageActions.filterByClassification('all')
  }
  closeMega(true)
})

var closingMegaID
function closeMega (closeMainAfter) {
  clearTimeout(closingMegaID)
  if ($('body').hasClass('mega-active')) {
    $('a.active', '#navbar').removeClass('active')
    $('body').removeClass('mega-active')
    if (closeMainAfter && !$(document.body).hasClass('home')) {
      closingMegaID = setTimeout(closeMain, 500)
    }
  } else if (closeMainAfter && !$(document.body).hasClass('home')) {
    closeMain()
  }
}
var closingID = null
var isOpening = null
function closeMain () {
  $('body').removeClass('open-menu')[0].isClosing = true
  clearTimeout(closingID)
  clearTimeout(isOpening)
  isOpening = null
  if (!$(document.body).hasClass('home') && document.documentElement.scrollTop < 86) {
    $(document.documentElement).animate({
      scrollTop: 86
    }, 300)
  }
  closingID = setTimeout(function () {
    $('body').removeClass('open-menu')[0].isClosing = false
  }, 500)
}
function openMain () {
  clearTimeout(closingID)
  clearTimeout(closingMegaID)
  isOpening = setTimeout(function () {
    isOpening = null
  }, 500)
  $('body').addClass('open-menu')
}

$('.close-mega').click(function (e) {
  e.preventDefault()
  closeMega(true)
})

function openSubMenuContent ($evt) {
  clearTimeout(closingID)
  clearTimeout(closingMegaID)
  $evt.preventDefault()
  $evt.stopPropagation()
  const $this = $(this)
  const $menus = $('.mega-menu')
  const $oldActive = $('a.active', '#navbar')

  if ($this.parent().hasClass('fonts')) {
    $('.fonts-mega').show()
    $('.client-work-mega').hide()
    $('.about-mega').hide()
    $('.fonts-submenu').show()
    $('.client-work-submenu').hide()
    $('.about-submenu').hide()
  }
  else if ($this.parent().hasClass('client')) {
    $oldActive.off('mouseover')
    $('.fonts-mega').hide()
    $('.client-work-mega').show()
    $('.about-mega').hide()
    $('.fonts-submenu').hide()
    $('.client-work-submenu').show()
    $('.about-submenu').hide()
  }
  else if ($this.parent().hasClass('about')) {
    $oldActive.off('mouseover')
    $('.fonts-mega').hide()
    $('.client-work-mega').hide()
    $('.about-mega').show()
    $('.fonts-submenu').hide()
    $('.client-work-submenu').hide()
    $('.about-submenu').show()
  }

  if (isOpening) return

  $oldActive.removeClass('active')
  $menus.removeClass('active')
  $('body').addClass('mega-active')
  $this.addClass('active')
  $('#fonts-menu-mega').addClass('active')
}
var fontsMenuOverID
$('#navbar .fonts a').on('mouseover', function ($evt) {
  $evt.preventDefault()
  $evt.stopPropagation()
  const self = this
  fontsMenuOverID = setTimeout(function () {
    if ($('body').hasClass('open-menu')) {
      openSubMenuContent.call(self, $evt)
    }
  }, 400)
}).on('mouseout', function () {
  clearTimeout(fontsMenuOverID)
}).on('click', function ($event) {
  $event.preventDefault()
})
// $('#navbar .client a, #navbar .about a').on('click', function ($evt) {
//   $(this).on('mouseover', $evt => $evt.stopPropagation())
//   openSubMenuContent.call(this, $evt)
// })
$('#main-header').on('mouseover', $evt => closeMega())

function openOnScroll () {
  const isOpen = $('body').hasClass('open-menu')
  if (!isOpen) {
    openMain()
  }
}
function closeOnScroll () {
  // scrolling down the page
  if ($('body').hasClass('home')) return
  const isOpen = $('body').hasClass('open-menu')
  const isMegaActive = $('body').hasClass('mega-active')
  if (isOpen && !isMegaActive) {
    if ($('body').removeClass('open-menu')[0].isClosing) {
      closeMega(true)
    }
  }
}

var lastPos = 0
function handleScroll () {
  const $doc = $(document)
  const scrollTop = $doc.scrollTop()
  if (lastPos > scrollTop) {
    openOnScroll()
  } else {
    closeOnScroll()
  }
  lastPos = scrollTop
}
window.addEventListener('scroll', handleScroll, passive())
function handleWheel (event) {
  if (event.wheelDelta > 0) {
    // scrolling up
    openOnScroll()
  } else if (event.wheelDelta < 0) {
    // scrolling down the page
    closeOnScroll()
  }
}
const body = $('body')[0]
body.addEventListener('mousewheel', handleWheel, passive())
body.addEventListener('wheel', handleWheel, passive())

var _sampleTextInputTID = 0
$('#font-detail .text-source input').on('change input', ($event) => {
  clearTimeout(_sampleTextInputTID)
  _sampleTextInputTID = setTimeout(() => {
    FontPageActions.updateAllSampleText($event.target.value)
    if (window.updateTesterImage) {
      window.updateTesterImage($event.target.value)
    }
  }, 250)
})

$('.close-main a').click(function (e) {
  e.preventDefault()
  if ($('body').hasClass('open-menu')) {
    $('body')[0].isClosing = true
    closeMega(true)
  } else {
    openMain()
  }
})
var openWaitingID = false
$('#secondary-header').on('mousemove', function ($event) {
  if (!$('body').hasClass('open-menu') &&
      !$('body')[0].isClosing &&
      $event.pageY - $(this).offset().top <= 12) {
    if (openWaitingID) return
    openWaitingID = setTimeout(function () {
      openWaitingID = false
      openMain()
    }, 400)
  } else {
    if (openWaitingID) {
      clearTimeout(openWaitingID)
      openWaitingID = false
    }
  }
})

// Util
// function deparam (p) {
//   const ret = {}
//   const seg = p.replace(/^\?/, '').split('&')
//   for (let i = 0, n = seg.length; i < n; i++) {
//     if (!seg[i]) continue
//     let s = seg[i].split('=', 1)
//     ret[s[0]] = s[1]
//   }
//   return ret
// }

// function checkCartItems (data) {
//   $('.cart-item-count').remove()
//   if ( data.length )
//     $('#main-cart-button').before('<span class="cart-item-count">'+data.length+'</span>')

//   // $('a[href*="/cart/?add="]').each(function( index, element ){
//   //   var add = parseInt( deparam( element.search ).add )
//   //   if ( jQuery.inArray( add, data ) + 1 )
//   //     $(element).addClass('item-in-cart').text('In Cart')
//   //   else
//   //     $(element).removeClass('item-in-cart').text('Add to Cart')
//   // })

//   if ( $('#cart .cart-table').length ) {
//     $('#cart .cart-table .row').each(function( index, element ) {
//       var remove = true, that = $(element)
//       data.forEach(function(entry){
//         if ( that.hasClass( 'item-row-' + entry ) )
//           remove = false
//       })
//       if ( remove )
//         $(this).remove()
//     })
//   }
// }

// Get cart items. Init.
// $.post( cart_url+'?ajax_get', function( data ) {
//   checkCartItems( data )
// })

// support retina and HiDPI
// $('.font-image').each(function () {
//   var $this = $(this)
//   var src = $this.attr('src')

//   // check for data-src
//   if (src === '#') src = $this.data('src')

//   // if we don't have an src, just abort.
//   if (!src) return

//   // add the resize multiplier
//   if (src.indexOf('rm=') === -1) {
//     src += '&rm=' + (window.devicePixelRatio || 1)
//   }

//   $this.attr('src', src)
// })

$('#secondary-header .font-types [data-font-filter]').click(function (e) {
  e.preventDefault()
  var $this = $(this)
  var filter = $this.data('font-filter')

  FontPageActions.filterByClassification(filter)
})
FontPageStore.listFilterChanged.add((filter) => {
  $('#secondary-header .font-types [data-font-filter]').each(function (i) {
    var $this = $(this)
    if ($this.data('font-filter') === filter) {
      $this.addClass('active')
    } else {
      $this.removeClass('active')
    }
  })
})
// assume all is the default
// $('#secondary-header .font-types [data-font-filter=all]').addClass("active")

// mount the buying options modal
function displayFont (fontID) {
  var product = products[fontID]
  invokeBuyingOptions(product)
}

// invoke the modal
$('.add-to-cart-button').on('click', function ($evt) {
  $evt.preventDefault()
  displayFont($(this).data('product-id'))
})
render(
  <BuyingOptions />,
  document.getElementById('modal-container')
)

if (/^\/fonts\/?$/.test(window.location.pathname)) {
  FontPageActions.filterByClassification('all')
}



// WEBPACK FOOTER //
// ./inc/js/app.js